var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.73 14.93a1.07 1.07 0 0 1-1.07-1.07v-3.2a1.07 1.07 0 1 1 2.13 0v3.2a1.07 1.07 0 0 1-1.06 1.07zM16 14.93a1.07 1.07 0 0 1-1.07-1.07V9.6a1.07 1.07 0 0 1 2.13 0v4.27A1.07 1.07 0 0 1 16 14.93zM20.27 14.93a1.07 1.07 0 0 1-1.07-1.07V7.47a1.07 1.07 0 1 1 2.13 0v6.4a1.07 1.07 0 0 1-1.06 1.06z",
    fill: "#4a4844",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.53 32H7.47a4.27 4.27 0 0 1-4.27-4.27V8.4a5.32 5.32 0 0 1 1.92-4.1L8.8 1.24A5.35 5.35 0 0 1 12.21 0h12.32a4.27 4.27 0 0 1 4.27 4.27v23.46A4.27 4.27 0 0 1 24.53 32zM12.21 2.13a3.21 3.21 0 0 0-2 .74L6.48 5.94A3.19 3.19 0 0 0 5.33 8.4v19.33a2.14 2.14 0 0 0 2.13 2.13h17.07a2.14 2.14 0 0 0 2.13-2.13V4.27a2.14 2.14 0 0 0-2.13-2.13z",
    fill: "#4a4844",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 25.6H9.6a1.07 1.07 0 1 1 0-2.13h12.8a1.07 1.07 0 1 1 0 2.13zM22.4 20.27H9.6a1.07 1.07 0 0 1 0-2.13h12.8a1.07 1.07 0 1 1 0 2.13z",
    fill: "#4a4844",
    "data-original": "#4a4844",
    className: "",
    opacity: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.53da83cc4cd81f07a919ff8a4cb1fba4.svg";
export { ForwardRef as ReactComponent };